import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

import { HttpInterceptorService } from "@ispm/core/services/http-interceptor.service";
import { ModalLoaderNgjsService } from "@ispm/layout/services/modal-loader-ngjs.service";
import * as _ from  'lodash';
import { IEndpoint } from "@ispm/shared/interfaces/endpoint.interface";


@Injectable({
  providedIn: 'root',
})
export class EndpointService {
  private ispmAdminEndpoint: any = {};
  private ispmWebEndpoint: any = {};
  private retries: number = 3;

  constructor(
    private http: HttpInterceptorService,
    private modalLoader: ModalLoaderNgjsService,
  ) {
  }

  /**
   * Get Genomics Admin endpoint data
   *
   * @return object | Observable<IEndpoint>
   */
  public getGenomicsIspmAdminEndpoint(): Observable<IEndpoint> {
    if (!_.isEmpty(this.ispmAdminEndpoint)) {
      return Observable.of(this.ispmAdminEndpoint);
    }

    return this.http.get('/endpoints/genomics-ispm-admin')
      .pipe(
        retry(this.retries),
        map((res: any) => res.json()),
        map((data: IEndpoint) => {
          return this.ispmAdminEndpoint = data;
        }),
        catchError((error: HttpErrorResponse) => {
          this.ispmAdminEndpoint = {};
          this.modalLoader.popupModal(this.modalLoader.ComponentsTypes.basic,
            {
              title: 'Genomics ISPM Admin is down',
              content: 'This part of application is unavailable now.  Please try again in a few minutes.'
            },
            "ALERT"
          ).subscribe();
          return Observable.throwError({});
        })
      )
    ;
  }

  /**
   * Get Genomics Web endpoint data
   *
   * @return object | Observable<IEndpoint>
   */
  public getGenomicsWebEndpoint(): Observable<IEndpoint> {
    if (!_.isEmpty(this.ispmWebEndpoint)) {
      return Observable.of(this.ispmWebEndpoint);
    }

    return this.http.get('/endpoints/genomics-web')
      .pipe(
        retry(this.retries),
        map((res: any) => res.json()),
        map((data: IEndpoint) => {
          return this.ispmWebEndpoint = data;
        }),
        catchError(() => {
          this.ispmWebEndpoint = {};
          this.modalLoader.popupModal(this.modalLoader.ComponentsTypes.basic,
            {
              title: 'Genomics ISPM is down',
              content: 'This part of application is unavailable now.  Please try again in a few minutes.'
            },
            "ALERT"
          ).subscribe();
          return Observable.throwError({});
        })
      )
    ;
  }
}
